import type { Obj } from "@paroicms/anywhere-lib";
import { fetchQuery } from "../shared/http-client";
import { type Statistics, formatToStatistics } from "./statistics.formatter";

export interface RequestError {
  error: string;
}

export async function fetchStatisticsByReferenceAPI(
  tableId: number,
  options?: {
    startedAt: string;
    endedAt: string;
  },
  page?: number,
): Promise<Statistics> {
  const params = new URLSearchParams();
  if (options) {
    params.set("started_at", options.startedAt);
    params.set("ended_at", options.endedAt);
  }
  if (page) {
    params.set("page", String(page));
  }
  const query = params.toString();
  const { data } = await fetchQuery<Obj>(`stats/${tableId}${query ? `?${query}` : ""}`);
  return formatToStatistics(data);
}

export async function fetchDashboardStatisticsAPI(): Promise<Statistics> {
  const { data } = await fetchQuery<Obj>("stats/dashboard");
  return formatToStatistics(data);
}
